import React, { forwardRef } from "react";
import { NavLink as RouterLink } from "react-router-dom";

const NavLink = forwardRef((props, ref) => (
  <RouterLink ref={ref} {...props} />
));

export default NavLink;
